import { __awaiter, __extends, __generator } from "tslib";
import { WEB_API } from '../web';
import ABaseNative from './native.base';
var WebNative = /** @class */ (function (_super) {
    __extends(WebNative, _super);
    function WebNative() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebNative.prototype.getCallHandler = function (target, method) {
        var _this = this;
        var _a;
        var handler = ((_a = WEB_API === null || WEB_API === void 0 ? void 0 : WEB_API[target]) === null || _a === void 0 ? void 0 : _a[method]) || null;
        if (!handler)
            throw new Error("no bridge api[".concat(target, ".").concat(method, "]"));
        handler = handler.bind(WEB_API[target]);
        return function (callbackId, params) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handler(params)];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, this.callback(callbackId, JSON.stringify(value))];
                }
            });
        }); };
    };
    return WebNative;
}(ABaseNative));
export default WebNative;
